<template>
    <!--收银赠送模块-->
    <div>
        <pop-form class="form-box" :state="show" width="680px" body-max-height="480px">
            <template slot="title">赠送</template>
            <div class="body-box">
                <div class="line-box">
                    <div class="pro-box">
                        <div class="box-title">
                            赠送项目或产品&nbsp;&nbsp;&nbsp;&nbsp;
                            <el-button type="text" @click="giveAddProduct(1)">添加项目</el-button>&nbsp;
                            <span class="split-line">|</span>&nbsp;
                            <el-button type="text" @click="giveAddProduct(2)">添加产品</el-button>
                        </div>
                        <div class="box-table">
                            <CashGiveProductList :content="formData.give_product"
                                @deleteProduct="deleteProduct"
                            />
                        </div>
                    </div>
                </div>
                <div class="line-box">
                    <div class="form-item">
                        <div class="label">
                            赠送积分
                        </div>
                        <div class="value">
                            <el-input v-model="formData.give_score" placeholder="" />
                        </div>
                    </div>
                    <div class="form-item">
                        <div class="label">
                            赠送金额
                        </div>
                        <div class="value">
                            <el-input v-model="formData.give_money" placeholder="" />
                        </div>
                    </div>
                </div>
                <div class="line-box">
                    <div class="form-item">
                        <div class="label">备注</div>
                        <div class="value">
                            <el-input type="textarea" :rows="4" placeholder="" v-model="formData.remark" />
                        </div>
                    </div>
                </div>
            </div>
            <template v-slot:foot>
                <div class="foot-box">
                    <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="editSubmit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </template>
        </pop-form>

        <!--选择项目-->
        <SelectProduct v-model="selectProState" :pro-type="selectProType" @done="selectedProDone" title="选择" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    import SelectProduct from "@/model/StoreUser/SelectProduct";
    import CashTextInput from "@/model/Cash/CashTextInput";
    import CashGiveProductList from "@/model/Cash/CashGiveProductList";
    export default {
        name: "CashGive",
        components: {CashGiveProductList, CashTextInput, SelectProduct, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: true
            },
            initData: {
                type: Object,
                default: {
                    give_money: "",
                    remarks: ""
                }
            }
        },
        data: () => ({
            formData: {
                give_product: [],
                give_money: "",
                give_score: "",
                remark: ""
            },
            scoreOption: {},

            selectProState: false,   //选择项目状态
            selectProType: 1,        //选择的类型
        }),
        methods: {
            close: function () {
                this.$emit("showChange", false);
            },
            editSubmit: function () {
                if(!obj.isEmpty(this.formData.give_score) && (
                    obj.isEmpty(this.scoreOption) || obj.isEmpty(this.scoreOption.receive_state)
                )) {
                    obj.message.error("请到积分设置开启积分");
                    return false;
                }

                this.$emit("submit", this.formData);
                this.close();
            },
            getScoreOption: function () {
                obj.postData("score/get_receive_option", {}, res => {
                    if(res.errcode === 0) {
                        this.scoreOption = res.data.option;
                    }
                });
            },

            //添加项目
            giveAddProduct: function (proType) {
                this.selectProType = proType;
                this.selectProState = true;
            },

            //选择结果
            selectedProDone: function (proList) {
                if(proList) {
                    proList.forEach(v => {
                        this.formData.give_product.push({
                            pro_id: v.id,
                            pro_type: this.selectProType,
                            title: v.title,
                            price: v.price,
                            num: 1,
                            expire_date: ""
                        });
                    });
                }
            },

            //删除项目
            deleteProduct: function (i) {
                this.formData.give_product.splice(i, 1);
            }
        },
        watch: {
            show: function (state) {
                if(state){
                    if(!obj.isEmpty(this.initData))
                        this.formData = obj.copyObject(this.initData);
                    this.getScoreOption();
                }else{
                    this.formData = {
                        give_product: [],
                        give_money: "",
                        give_score: "",
                        remark: ""
                    };
                }
            }
        }
    }
</script>

<style scoped>
    .body-box{
        padding: 10px 10px 0px;
    }
    .line-box{
        margin-bottom: 20px;
        display: flex;
    }
    .foot-box{
        padding: 0 20px 10px;
        text-align: right;
    }
    .form-item{
        line-height: 50px;
        flex: 1;
    }
    .form-item>.label{
        width: 80px;
        float: left;
        text-align: right;
    }
    .form-item>.value{
        margin-left: 90px;
    }
    .split-line{
        color: #cccccc;
    }
    .pro-box{
        width: 100%;
    }
    .box-table{
        height: 200px;
        overflow: hidden;
        display: flex;
    }
</style>
